export const PAGE_VIEWED = 'Page Viewed'
export const API_TEST_RUN = 'API Test Run'
export const INTEGRATION_ACTION = 'Integration Action'
export const USER_LOGGED_IN = 'User Logged In'
export const SANDBOX_ACTION = 'Sandbox Action'
export const SERVICE_APP_ACTION = 'Service App Action'
